import { CmsApplianceDetailsModelSerialExpiredLink } from '../../models/appliance-details-model-serial/cms-appliance-details-model-serial-expired-link.interface';

export const mockCmsApplianceDetailsModelSerialExpiredLink: CmsApplianceDetailsModelSerialExpiredLink =
  {
    title: 'title',
    body: '<p>body</p>',
  };
